import { render, staticRenderFns } from "./posExceptPage.vue?vue&type=template&id=c0de7e10"
import script from "./posExceptPage.vue?vue&type=script&lang=js"
export * from "./posExceptPage.vue?vue&type=script&lang=js"
import style0 from "./posExceptPage.vue?vue&type=style&index=0&id=c0de7e10&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports